import React from "react";
import Select from "react-select"; // Import react-select

const SearchDropDownWithLabel = ({
  labelName,
  lableclassName,
  name,
  options,
  value,
  handleSelect,
  className = "",
  disabled = false,
  showastrict = false,
  message = "",  // New prop to pass the message
}) => {
  return (
    <div className="dropdown-container">
      <div className="searchdropdown">
        <label className={lableclassName}>{labelName}{showastrict && <span className="text-danger">*</span>}</label>
        <Select
          name={name}
          className={`form-select ${className}`}
          value={options?.find((option) => option.value === value)} // Set the selected value
          onChange={handleSelect}
          options={options}
          isSearchable={!disabled} // Disable search if dropdown is disabled
          isDisabled={disabled} // Disable select if needed
          placeholder="Select" // Placeholder text
        />
      </div>
      {/* Display a message if the dropdown is disabled */}
      {disabled && message && (
        <div className="disabled-message" style={{ color: "red", marginTop: "5px", fontSize: "8px" }}>
          {message}
        </div>
      )}
    </div>
  );
};

export default SearchDropDownWithLabel;


